<!-- <div class="registration-modal modal">
  <div class="title"><img src="../../../../../assets/svg/icons/check.svg"/>
    <h2>{{data.message}}</h2>
  </div>
  <button class="button stroke error-ok" type="button" (click)="dialogRef.close()">Ok</button>
</div> -->
<p (click)="closeClick()"><b>Success! </b><span>{{data.message}}</span></p>
